/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Container(theme: Theme): any {
  return {
    MuiContainer: {
      styleOverrides: {
        root: { [theme.breakpoints.up("sm")]: { paddingLeft: theme.spacing(4), paddingRight: theme.spacing(4) } },
      },
    },
  };
}
